import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

export const AdvocateStepHeading: React.FC<Props> = ({ title, subtitle, className, titleClassName }) => {
	return (
		<div className={cn('space-y-4 text-center text-balance', className)}>
			<Text
				as="h1"
				className={cn('text-typography-strong mx-0 block', titleClassName)}
				variant="heading"
				size="x-large"
			>
				{title}
			</Text>

			{subtitle && <Text className="text-typography-weak block">{subtitle}</Text>}
		</div>
	);
};

type Props = {
	title: string;
	subtitle?: string | React.ReactNode;
	className?: string;
	titleClassName?: string;
};
